import DoughnutChart from "../../../components/Doughnut.vue";
import AdminPageDataTable from "../../../components/AdminPageDataTable.vue";
import api from "./api.js"
export default {
    components: {
        DoughnutChart, AdminPageDataTable
    },
    data: () => ({valid: true,
      addDialog: false,
        apiLink: "api/web/country/get-admin-countries",
        apiSaveLink: "api/web/country/save", apiSaveImgLink: "api/web/country/save-img",
        apiDeleteLink: "api/web/country/delete",
        slots: [{ title: 'item.title', header: 'title', type: 'text', col: 'title' },
        { title: 'item.items', header: 'items', type: 'table' },
        { title: 'item.img', header: 'img', type: 'image', link: 'countries/', col: 'img' },],
        switchSlots: [], fields: [{
            title: '', image: null, image_url: '', image_base64: '', image_title: '',
        }],
        headers: [

            { text: 'Id', value: 'id' },
            { text: 'Title', value: 'title' },
            { text: 'Image', value: 'img' },
            { text: 'Nb of products', value: 'items' },
            { text: 'Actions', value: 'actions' },
        ],
        loaded: false,
        chartData: {},
        value: [15, 20, 5, 100, 23, 44, 71, 22, 0, 0, 0],
        labels: [15, 20, 5, 100, 23, 44, 71, 22, 0, 0, 0],
    }),
    mounted() {
        this.fetchStat();


    },
    methods: {
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(",")[1]);
                reader.onerror = (error) => reject(error);
            })
        },
        Preview_image(index) {
            if (this.fields[index].image == null) {
                this.fields[index].image_url = '';
                this.fields[index].image_base64 = '';
            }
            else {                
                this.getBase64(this.fields[index].image).then((res) => {
                    this.fields[index].image_base64 = res
                });
                this.fields[index].image_url = URL.createObjectURL(this.fields[index].image);
                this.fields[index].image_title = this.fields[index].image.name
            } 
     
        },
        saveRows() {
            if (!this.$refs.form.validate()) {
                return
            }
            else {
                this.$store.state.loading = true;
                const records = [];
                this.fields.forEach(element => {
                    records.push({
                        title:element.title,
                        image_base64:element.image_base64,
                        image_title:element.image_title
                    })
                });
                api.batchAddRows(records).then((res) => {
                    if (res.data.responseCode === 1) {

                        this.fetchStat();
                        this.$store.state.loading = false;

                    }
                    this.fields = [{
                        title: '', image: null, image_url: '', image_base64: '', image_title: '',
                    }];
                    this.addDialog = false;
                });
            }
        },
        addRow() {
            this.fields.push({  title: '', image: null, image_url: '', image_base64: '', image_title: '',});
        },
        removeRow(index) {
            this.fields.splice(index, 1);
        },
        randomColor() {
            const r = () => Math.floor(256 * Math.random());

            return `rgb(${r()}, ${r()}, ${r()})`;
        },
        fetchStat() {
            this.loaded = false;
            api.getStat()
                .then((res) => {
                    if (res.data.responseCode === 1) {
                        var labels = []
                        var data = []
                        var backgroundColor = []
                        res.data.data.forEach(element => {
                            labels.push(element.title);
                            data.push(element.items.length);
                            backgroundColor.push(this.randomColor())
                        });
                        this.chartData = {
                            labels: labels,
                            datasets: [
                                {
                                    backgroundColor: backgroundColor,
                                    data: data,
                                },
                            ],
                        }
                        this.loaded = true;
                    }
                });
        },

    },

};